var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "m17.134 8.49-6.25-6.25a1.25 1.25 0 0 0-1.768 0l-6.25 6.25a1.24 1.24 0 0 0-.366.885v7.5a.625.625 0 0 0 .625.625h13.75a.624.624 0 0 0 .625-.625v-7.5a1.24 1.24 0 0 0-.366-.884m-.884 7.76H3.75V9.375L10 3.125l6.25 6.25z"
  })));
};
export default SvgHome;